import { createPortal } from "react-dom"
import Div from "../Div"
import Form from "../Form"
import FormButton from "../FormButton"
import Input from "../Input"
import { createZohoTask } from "../../http/ZohoHttp"
import { useState } from "react"
import Spinner from "../Spinner"


export default function CreateZohoTaskModal({handleClicked, ...props }) {

    
    const [isLoading, setIsLoading] = useState(false)

    function handleClose() {
        handleClicked(false)
    }

    async function handleSubmit(event) {
        setIsLoading(true)
        event.preventDefault();
        const fd = new FormData(event.target)
        const data = Object.fromEntries(fd.entries())
        console.log(data)
        const zohoResponse = await createZohoTask(data)
        console.log(zohoResponse)
        setIsLoading(false)
        window.location.reload()
    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', maxWidth: '100%' }}>

                        <Div className="form-group">
                            Follow Up Comments
                        </Div>


            {isLoading ? <Spinner /> : null}
                        <Form onSubmit={handleSubmit}>
                            <Div className="mb-3">
                                <label className="form-label">Enter Subject</label>
                                <Input type="text" className="form-control" name="subject" style={{ opacity: '0.8' }}
                                    id="subject" placeholder="" />

                            </Div>
                            <Div className="mb-3">
                                <label className="form-label">Enter Description</label>
                                <textarea className="form-control" name="description" id="description" rows="3"
                                    style={{ opacity: '0.8' }}
                                ></textarea>
                            </Div>
                            <FormButton type="submit" className="btn btn-primary">Submit</FormButton>
                            <FormButton type="submit" className="btn btn-primary" style={{ marginLeft: '10px' }}
                            onClick={handleClose}>Close</FormButton>
                        </Form>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}